import { featureFlag } from "../constants/feature";
import { isHomeHealthExternalUser } from "../constants/sso";

const INTERNAL_EMAIL_DOMAINS = [
  "@circadia.health",
  "@circadia.com",
  "@circadiatech.com",
] as const;

type NavigatorUser = {
  email?: string | null;
  groups?: string[] | null;
};

export const isInternalCipUser = (user?: NavigatorUser): boolean => {
  if (!user?.email) return false;
  if (isHomeHealthExternalUser(user.groups, user.email)) return false;

  const email = user.email.trim().toLowerCase();

  // PCC SSO customer identities may use synthetic @circadia.health emails.
  if (email.startsWith("pcc_")) return false;

  return INTERNAL_EMAIL_DOMAINS.some((domain) => email.endsWith(domain));
};

export const canUseNavigatorCustomTodo = (user?: NavigatorUser): boolean =>
  featureFlag.navigatorCustomTodo && isInternalCipUser(user);
